function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkipForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 4.16668V15.8333M4.16675 3.33334L12.5001 10L4.16675 16.6667V3.33334Z",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForward);
export default __webpack_public_path__ + "static/media/skip-forward.45c0e9727f14459b14b6041402e77958.svg";
export { ForwardRef as ReactComponent };